import React from "react";
import CasesHero from "../../pages/cases/CasesHero";

import ContactCta from "../main_page/ContactCta";
import LanglShowcase from "./LanglShowcase";
import QlashShowcase from "./QlashShowcase";
import VPNShowcase from './VPNShowcase';
import CleanersShowcase from './CleanersShowcase';
import AIproductsShowcase from './AIproductsShowcase';
import TimeAppsShowcase from './TimeAppsShowcase';
import WebsitesShowcase from "./WebsitesShowcase";
import Footer from "../Footer";
import Reveal from "../../components/Reveal";
import AiAgentsCases from "./AiAgentsCases";
import AppsShowcase from "./AppsShowcase";
import WebsitesShowcase_2 from './WebsitesShowcase-2'


export default function CasesPage() {
  return (
    <div className="contacts-page">
      <Reveal as="section" variant="fade" duration={0.8} threshold={0.15}>
        <CasesHero />
      </Reveal>

      <Reveal
        as="section"
        variant="fade"
        threshold={0.15}
      >
        <AiAgentsCases />
      </Reveal>

      <Reveal as="section" variant="fade" threshold={0.15}>
        <AppsShowcase />
      </Reveal>

      <Reveal as="section" variant="fade" threshold={0.15}>
        <WebsitesShowcase_2 />
      </Reveal>

      {/* <LanglShowcase/>
      <QlashShowcase/>
      <VPNShowcase/>
      <CleanersShowcase/>
      <AIproductsShowcase/>
      <TimeAppsShowcase/>
      <WebsitesShowcase/> */}
      <Reveal as="section" variant="zoom" delay={0.08}>
        <ContactCta />
      </Reveal>
      <Footer />
    </div>
  );
}